import { Card, CardBody, Flex, Text, VStack, useColorModeValue } from "@chakra-ui/react";

export const ContractStatCard = ({ label, value, color, icon }) => {
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const textColor = useColorModeValue("gray.600", "gray.300");

  return (
    <Card
      bg={bgColor}
      shadow="lg"
      borderRadius="xl"
      border="1px"
      borderColor={borderColor}
      transition="all 0.2s"
      _hover={{ shadow: "xl", transform: "translateY(-4px)" }}
      overflow="hidden"
    >
      <CardBody>
        <VStack spacing={4} align="center">
          <Flex
            w="60px"
            h="60px"
            bg={`${color}.100`}
            borderRadius="full"
            align="center"
            justify="center"
          >
            <Text fontSize="2xl">{icon}</Text>
          </Flex>

          <VStack spacing={1} align="center">
            <Text fontSize="4xl" fontWeight="bold" color={`${color}.600`}>
              {value}
            </Text>
            <Text fontSize="md" color={textColor} textAlign="center" fontWeight="medium">
              {label}
            </Text>
          </VStack>
        </VStack>
      </CardBody>
    </Card>
  );
};
